module.exports = __webpack_public_path__ + "static/media/clevis_twisted.195e3edf.webp";